<template>
    <v-flex xl12>
        <v-card flat>
            <v-card-text>
                <v-snackbar top v-model="success" color="success">
                    <span> <v-icon>check_circle</v-icon> {{messages}} </span>
                </v-snackbar>
                <v-snackbar top v-model="error" color="error">
                    <span> <v-icon>info</v-icon> {{messages}} </span>
                </v-snackbar>
                <h3>Responder</h3>
                <v-form ref="form" v-model="valid" lazy-validation>

                    <h3>{{register.full_name}}</h3>
                    <label>E-mail</label>
                    <p>{{register.email}}</p>
                    <label>Celeulat/ Telefone</label>
                    <p>{{register.phone}}</p>

                    <div class="ipsCode">
                        {{register.comment}}
                    </div>

                    <v-divider></v-divider>

                    <br/>

                    <v-flex xl12 lg12 md6 sm12 xs12>
                        <label>Réplica</label>
                        <ckeditor id="editor1" v-model="register.reply" required></ckeditor>
                    </v-flex>


                    <v-btn flat class="primary" @click="submit">Salvar</v-btn>
                    <v-btn flat class="secondary" @click="clear">Cancelar</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<style>
    .ipsCode {
        background: #fafafa;
        padding: 15px !important;
        border: 0 !important;
        border-left: 4px solid #e0e0e0 !important;
        clear: both;
        direction: ltr;
        word-wrap: normal;
    }
</style>

<script>
    import Ckeditor from "../../components/Ckeditor";

    export default {
        components: {Ckeditor},
        name: 'survey-reply',
        data: () => ({
            register: JSON.parse(localStorage.getItem('register')),
            valid: true,
            error: false,
            success: false,
            messages: '',
            nameRules: [
                v => !!v || 'Campo obrigatório',
            ],
            emailRules: [
                v => !!v || 'O E-mail é obrigatório',
                v => /.+@.+/.test(v) || 'E-mail inválido'
            ],
        }),
        methods: {
            submit() {
                var self = this
                this.error = false
                this.messages = ''
                if (this.$refs.form.validate()) {
                    self.$store.commit('setLoading', true)
                    this.axios.post('/reply-survey.json', this.register, {
                        headers: {
                            'Authorization': this.$store.state.token
                        }
                    }).then(function (response) {
                        self.loading = false
                        if (response.data.success === true) {
                            self.$store.commit('setLoading', false)
                            self.messages = response.data.messages
                            self.success = true
                            setTimeout(function () {
                                self.$router.push('/surveys')
                            }, 2000)
                        } else {
                            self.error = true
                            self.loading = false
                            self.messages = response.data.messages
                        }
                    })
                }
            },
            clear() {
                this.register.full_name = ''
                this.register.email = ''
                this.$router.push('/surveys')
            }
        },
        mounted: function () {
            this.$nextTick(function () {

            })
        }
    }
</script>
